// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/** `register_surface` value pack forms declare to feed this register. */
export const IDENTITY_EXCHANGE_REGISTER_SURFACE = 'identity_exchange';
/** The form field ids whose `options[]` the register reads. */
export const IDENTITY_EXCHANGE_VOCABULARY_FIELDS = {
    countries: 'identity_provider_country',
    directions: 'direction',
    authorisationStates: 'formal_authorisation',
};
/**
 * The one authorisation value the gate accepts as "authorised". Platform
 * vocabulary shared with the template: the gate is a platform control, and
 * the template's option values are required to include it.
 */
export const IDENTITY_EXCHANGE_AUTHORISED_VALUE = 'authorised';
/** The value a new record's authorisation starts at. */
export const IDENTITY_EXCHANGE_NOT_AUTHORISED_VALUE = 'not_authorised';
export const IDENTITY_EXCHANGE_COLLECTION = 'grc_identity_exchange_records';
/** The transfer-assessment status the gate accepts (the assessments module's own value). */
export const IDENTITY_EXCHANGE_TRANSFER_ASSESSMENT_APPROVED_STATUS = 'approved';
/**
 * The fields that define the flow or carry the gate. A change to any of them on
 * a `production` record returns it to `testing` and clears the production
 * approval: whoever approved production approved THIS flow, not a later one.
 * The recording fields (outcome recording, reconciliation, log location,
 * retention) do not define the flow and do not demote.
 */
export const IDENTITY_EXCHANGE_FLOW_DEFINING_FIELDS = [
    'identity_provider',
    'identity_provider_country',
    'relying_party',
    'relying_party_country',
    'purpose',
    'direction',
    'attributes',
    'minimisation_confirmed',
    'transfer_assessment_id',
    'authorisation',
    'identity_profile_id',
];
/**
 * `production` is reachable only through the gate. A new record cannot start
 * there, and `retired` is terminal.
 */
export const IDENTITY_EXCHANGE_STATUSES = ['modelled', 'testing', 'production', 'retired'];
/**
 * The four things the gate requires, each named in a refusal when absent.
 * `transfer_assessment` is satisfied only by an assessment in this organisation
 * whose status is {@link IDENTITY_EXCHANGE_TRANSFER_ASSESSMENT_APPROVED_STATUS};
 * a draft, rejected or deprecated assessment does not carry a flow.
 */
export const IDENTITY_EXCHANGE_GATE_ITEMS = [
    'legal_basis_per_attribute',
    'minimisation_confirmed',
    'transfer_assessment',
    'formal_authorisation',
];
export const IDENTITY_EXCHANGE_ERROR_CODES = {
    optionNotDeclared: 'IDENTITY_EXCHANGE_OPTION_NOT_DECLARED',
    gateNotSatisfied: 'IDENTITY_EXCHANGE_GATE_NOT_SATISFIED',
    retired: 'IDENTITY_EXCHANGE_RETIRED',
    profileNotFound: 'IDENTITY_EXCHANGE_PROFILE_NOT_FOUND',
    assessmentNotFound: 'IDENTITY_EXCHANGE_ASSESSMENT_NOT_FOUND',
    notFound: 'IDENTITY_EXCHANGE_NOT_FOUND',
    /** The record changed between this request's read and its write; re-read and retry. */
    concurrentChange: 'IDENTITY_EXCHANGE_CONCURRENT_CHANGE',
    /** A status change to the status the record already holds. */
    sameStatus: 'IDENTITY_EXCHANGE_SAME_STATUS',
};
//# sourceMappingURL=identity-exchange.js.map